import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.scss'
Vue.use(ElementUI);
Vue.config.productionTip = false

Vue.prototype.$api = {}
Vue.prototype.$api.uploadImgUrl = 'https://app.lanxinhenan.com/api/SupplyHall/uploadFile'


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
